import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=0ba74ef1&scoped=true&"
import script from "./StatsCard.vue?vue&type=script&lang=ts&"
export * from "./StatsCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=0ba74ef1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba74ef1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VIcon,VRow})
